export default __webpack_public_path__ + "static/media/vinhthanh.0cda9047.png";